import { Committee } from './committees.types';
import { IPageInfo } from './page.types';

export type CardsSortBy =
  | 'id'
  | 'tasksSolutionSheetId'
  | 'bundleNumber'
  | 'bundleName'
  | 'bundleSheetCode'
  | 'examCommitteeShortName'
  | 'examineeSchoolCode'
  | 'examineeIdentity'
  | 'bundleImportDate'
  | 'statuses'
  | 'tasksSolutionSheetPageCount';

export interface ISolutionCard {
  sheetCode: string;
  bundleNumber: string;
  bundleName: string;
  schoolCode: string;
  examCommitteeId: Committee;
  examineeIdentifier: string;
  solutionSheetIdentifier: string;
  pages: IPages[];
  statusId: TasksSolutionSheetStatusId;
}

interface IPages {
  pageId: string;
  pageNumber: string;
}
export interface ISolutionCardsTableFilter {
  bundleNumber: null;
  bundleSheetCode: null;
  examCommitteeFilter: null;
  examineeSchoolCode: null;
  examineeIdentity: null;
  bundleImportFrom: null;
  bundleImportTo: null;
}

export interface ISolutionCardsTableSort {
  sortByProperty: string;
  isDescending: boolean;
}

export interface ITasksSolutionSheet {
  id: string;
  tasksSolutionSheetId: string;
  bundleId: string;
  bundleNumber: number;
  bundleName: string;
  bundleSheetCode: string;
  examineeId: string;
  examCommitteeId: Committee;
  examineeSchoolCode: string;
  examineeIdentity: string;
  examineePesel: string;
  examineeIdentityCardNo: string;
  bundleImportDate: Date;
  processingDate: Date;
  totalExamSheetPagesCount: number;
  importedSolutionPagesCount: number;
  tasksSolutionSheetStatusId: TasksSolutionSheetStatusId;
}

export interface ITasksSolutionSheetDto {
  tasksSolutionSheetId: string;
  bundleNumber: number;
  bundleName: string;
  bundleSheetCode: string;
  examCommitteeId: Committee;
  examineeSchoolCode: string;
  examineeIdentity: string;
}

export interface ISolutionCardsTable {
  filter: ISolutionCardsTableFilter;
  sort: ISolutionCardsTableSort;
  page: IPageInfo;
  tasksSolutionSheets: ITasksSolutionSheet[];
}

export enum TasksSolutionSheetStatusId {
  DownloadError,
  ScanError,
  ExamSheetLack,
  ExamineeLack,
  DuplicatedSheet,
  IncompleteSheet,
  CompleteSheet,
  New,
}

export const TasksSolutionSheetStatusDetail = (
  statusId: TasksSolutionSheetStatusId,
): { color: string; label: string } => {
  switch (statusId) {
    case TasksSolutionSheetStatusId.DownloadError:
      return { color: '#FF5C45', label: 'Błąd pobierania' };
    case TasksSolutionSheetStatusId.ScanError:
      return { color: '#3C419A', label: 'Błąd skanowania' };
    case TasksSolutionSheetStatusId.ExamSheetLack:
      return { color: '#A45CFF', label: 'Brak arkusza' };
    case TasksSolutionSheetStatusId.ExamineeLack:
      return { color: '#26A4FF', label: 'Brak zdającego' };
    case TasksSolutionSheetStatusId.DuplicatedSheet:
      return { color: '#3560FF', label: 'Duplikat' };
    case TasksSolutionSheetStatusId.IncompleteSheet:
      return { color: '#EA2075', label: 'Karta niekompletna' };
    case TasksSolutionSheetStatusId.CompleteSheet:
      return { color: '#347F42', label: 'Kompletna' };
    case TasksSolutionSheetStatusId.New:
      return { color: '#FF9A02', label: 'Nowa' };
    default:
      return { color: '', label: '' };
  }
};

export const getTasksSolutionSheetStatusIdList = (name: string) => {
  const splittedTasksSolutionSheetStatusIds: string[] = name.split(',');
  const result = splittedTasksSolutionSheetStatusIds.map((status) => {
    switch (status) {
      case 'Błąd pobierania':
        return TasksSolutionSheetStatusId.DownloadError.toString();
      case 'Błąd skanowania':
        return TasksSolutionSheetStatusId.ScanError.toString();
      case 'Brak arkusza':
        return TasksSolutionSheetStatusId.ExamSheetLack.toString();
      case 'Brak zdającego':
        return TasksSolutionSheetStatusId.ExamineeLack.toString();
      case 'Duplikat':
        return TasksSolutionSheetStatusId.DuplicatedSheet.toString();
      case 'Karta niekompletna':
        return TasksSolutionSheetStatusId.IncompleteSheet.toString();
      case 'Kompletna':
        return TasksSolutionSheetStatusId.CompleteSheet.toString();
      case 'Nowa':
        return TasksSolutionSheetStatusId.New.toString();
      default:
        return '';
    }
  });
  return result;
};

export interface IUpdateSolutionData {
  isChangeSaved: boolean;
  statusId: TasksSolutionSheetStatusId;
  examineeIdentifier: string | null;
}

export enum DeleteTasksSolutionSheetEnumResult {
  SheetDownloadedBySampleAssessmentGroup,
  SheetDownloadedToEvaluation,
  Success,
  ErrorWhileRequestingScoringService,
  Failed,
}
